"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class LocaleProvider extends _react.Component {
  getChildContext() {
    const {
      locale
    } = this.props;
    return {
      locale
    };
  }
  render() {
    // `Children.only` enables us not to add a <div /> for nothing
    const {
      children
    } = this.props;
    return _react.Children.only(children);
  }
}
LocaleProvider.propTypes = {
  locale: _propTypes.default.object.isRequired,
  children: _propTypes.default.node.isRequired
};
LocaleProvider.childContextTypes = {
  locale: _propTypes.default.object.isRequired
};
var _default = LocaleProvider;
exports.default = _default;